export default {
  refreshComponentObj (state) {
    return state.refreshComponentObj
  }
}
